<!-- Loading Screen -->

@if (isReportSending) {
  <div class="wrapper center"
    >
    <div class="inner">
      <mat-spinner> </mat-spinner>
    </div>
  </div>
}

<!-- Gill Net Catch Report-->

@if (!isReportSending) {
  <div class="container catch-container">
    <div class="container"
      style="padding-top: 20px;">
      <div class="row"
        align="center">
        @if (currPage <= numPages) {
          <h6 i18n>
        <small class="text-muted">
          Page {{currPage}} of {{numPages}}
        </small>
      </h6>
        }
        @if (currPage > numPages) {
          <h6 i18n>
        <small class="text-muted">
          Gillnet Catch Report
        </small>
      </h6>
        }
      </div>
      <div class="row" align="center">
        <div class="col" style="display: flex; justify-content: space-between;">
          <mat-icon></mat-icon>
          @if (currPage <= numPages) {
            <mat-spinner
              mode="determinate"
              [diameter]="50"
              [strokeWidth]="6"
            [value]="spinnerProgress"></mat-spinner>
          }
          @if (currPage > numPages && !isComplete) {
            <mat-icon
              style="color:#3ebfb9">
              check_circle_outline
            </mat-icon>
          }
          @if (!isComplete) {
            <button mat-mini-fab matTooltip="Delete Report" [disabled]="isEditing" style="background-color: #005d87;" (click)="deleteReport()">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
    <form [formGroup]="gillnetForm">
      <!--   Hiding national requirements  When was the start of the fishing effort?
      <div *ngIf="currPage === 1" class="container">
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
            When was the start of the fishing effort?
          </h5>
        </div>
        <div class="row"
          align="center">
          <div class="col-2"></div>
          <div class="col-8">
            <mat-card class="demo-inline-calendar-card" style="margin-top: 10%">
              <mat-calendar [minDate]="sharedMethodsService.getMinDate(currTrip)" [maxDate]="currDate" [(selected)]="effortStartDate" (selectedChange)="dateTimeChange()"></mat-calendar>
            </mat-card>
            <div class="outer">
              <div class="inner-2">
                <h6 i18n class="blue-label">
                  Time (24hr): &nbsp;
                </h6>
              </div>
              <div class="inner-2">
                <ngb-timepicker ngDefaultControl class="time-picker"
                  [spinners]="false"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="effortStartTime"
                (ngModelChange)="dateTimeChange()"></ngb-timepicker>
              </div>
              <mat-error i18n *ngIf="!effortStartTime"
                style="margin-left: 15px;">
                Required
              </mat-error>
            </div>
          </div>
          <div class="col-2"></div>
        </div>
      </div>
      <!--       Hiding national requirements  When was the end of the fishing effort?
      <div *ngIf="currPage === 2"
        class="container">
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
            When was the end of the fishing effort?
          </h5>
        </div>
        <div class="row"
          align="center">
          <div class="col-2"></div>
          <div class="col-8">
            <mat-card class="demo-inline-calendar-card"
              style="margin-top: 10%">
              <mat-calendar [minDate]="effortStartDate" [maxDate]="currDate" [(selected)]="effortEndDate" (selectedChange)="dateTimeChange()"></mat-calendar>
            </mat-card>
          </div>
          <div class="outer">
            <div class="inner-2">
              <h6 i18n class="blue-label">
                Time (24hr): &nbsp;
              </h6>
            </div>
            <div class="inner-2">
              <ngb-timepicker class="time-picker"
                [spinners]="false"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="effortEndTime"
              (ngModelChange)="dateTimeChange()"></ngb-timepicker>
            </div>
            <mat-error i18n *ngIf="!effortEndTime"
              style="margin-left: 15px;">
              Required
            </mat-error>
          </div>
          <div class="col-2"></div>
        </div>
      </div>
      <!--       Hiding national requirements  Indicators for SAR, Lost Gear, and MMI, License # and effort description
      <div *ngIf="currPage === 3" class="container">
        <h5 i18n align="center" class="blue-heading-title">
          Please describe the fishing effort
        </h5>
        <div class="row" style="padding-top: 50px;">
          <div style="display: flex; justify-content: flex-start; align-items: center;">
            <h6 i18n style="margin-bottom: 0; color: #005d87; font-weight: bold; padding-right: 20px;">Was there any interaction with a species at risk during this fishing effort?</h6>
            <mat-radio-group formControlName="sarIndicator" aria-label="Select an option">
              <mat-radio-button i18n [value]="true">Yes</mat-radio-button>
              <mat-radio-button i18n [value]="false">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <h6 i18n *ngIf="gillnetForm.get('sarIndicator')?.value" style="color: red; margin-top: 10px; font-style: italic;">Please, complete the section concerning species at risk interactions</h6>
        </div>
        <div class="row" style="padding-top: 25px;">
          <div style="display: flex; justify-content: flex-start; align-items: center;">
            <h6 i18n style="margin-bottom: 0; color: #005d87; font-weight: bold; padding-right: 20px;">Did you lose or find any of your fishing gear during this fishing effort?</h6>
            <mat-radio-group formControlName="lostGearIndicator" aria-label="Select an option">
              <mat-radio-button i18n [value]="true">Yes</mat-radio-button>
              <mat-radio-button i18n [value]="false">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <h6 i18n *ngIf="gillnetForm.get('lostGearIndicator')?.value" style="color: red; margin-top: 10px; font-style: italic;">Please, complete the declaration concerning gears that were lost or found</h6>
        </div>
        <div class="row" style="padding-top: 25px;">
          <div style="display: flex; justify-content: flex-start; align-items: center;">
            <h6 i18n style="margin-bottom: 0; color: #005d87; font-weight: bold; padding-right: 20px;">Was there any interaction with a marine mammal during this fishing effort?</h6>
            <mat-radio-group formControlName="marineMammalIndicator" aria-label="Select an option">
              <mat-radio-button i18n [value]="true">Yes</mat-radio-button>
              <mat-radio-button i18n [value]="false">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <h6 i18n *ngIf="gillnetForm.get('marineMammalIndicator')?.value" style="color: red; margin-top: 10px; font-style: italic;">Please, complete the section concerning marine mammal interactions</h6>
        </div>
        <div class="row">
          <h6 i18n class="blue-heading">
            What is your license number?
          </h6>
          <mat-form-field appearance="outline">
            <mat-label i18n>
              License #
            </mat-label>
            <input matInput formControlName="licenseNum">
          </mat-form-field>
        </div>
        <div class="row">
          <h6 i18n class="blue-heading">
            Fishing effort comments
          </h6>
          <mat-form-field appearance="fill">
            <mat-label i18n>
              Comments...
            </mat-label>
            <textarea matInput
              maxlength="400"
              rows="4"
            formControlName="effortComments"></textarea>
          </mat-form-field>
        </div>
      </div>
      <!-- Select or Add Net -->
      @if (currPage === 1) {
        <div
          class="container">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          Which net did you use to fish?
        </h5>
          </div>
          <div class="row">
            <div class="col-2"></div>
            <div class="col-8">
              <mat-radio-group class="radio"
                formControlName="net">
                @for (net of userNets; track net) {
                  <mat-radio-button
                    [value]="net"
                    [checked]="net.isChecked">
                    <h6 style="font-weight: bold">
                      <small i18n class="text-muted text-small">
                  {{net}} ({net.netType, select, Alaska Twist {Alaksa Twist} Multi Strand {Multi Strand} Combination {Combination}})
                </small>
                    </h6>
                  </mat-radio-button>
                }
              </mat-radio-group>
            </div>
            <div class="col-2"></div>
          </div>
          <div class="row add-item"
            align="center">
            <div class="col-2"></div>
            <div class="col-8">
              <div class="row">
                <button mat-raised-button
                  class="fishing-button-red"
                  type="button"
                  (click)="addNetDialog()">
                  <span i18n>
                Add New Net
              </span>
                </button>
              </div>
            </div>
            <div class="col-2"></div>
          </div>
        </div>
      }
      <!-- Catch Date & Hours Fished -->
      @if (currPage === 2) {
        <div class="container">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          Please provide the catch date.
        </h5>
          </div>
          <div class="row"
            align="center">
            <div class="col-2"></div>
            <div class="col-8">
              <mat-card class="demo-inline-calendar-card calendar-width"
                style="margin-top: 10%">
                <mat-calendar [(selected)]="catchDate" (selectedChange)="dateTimeChange()" [minDate]="sharedMethodsService.getMinDate(currTrip)" [maxDate]="currDate"></mat-calendar>
              </mat-card>
              @if (hasDuplicateDate) {
                <small i18n class="red-label">
            DFO has already confirmed a catch or pause report for this date. Only one catch or pause report per day is accepted, so this report will be returned as an error.
          </small>
              }
            </div>
          </div>
        </div>
      }
      <!-- Management Area, Subarea, Number of Sets -->
      @if (currPage === 3) {
        <div class="container">
          <h5 i18n align="center" class="blue-heading-title">
        Area and effort details
      </h5>
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          Where did you fish?
        </h5>
          </div>
          <div class="row">
            <h6 i18n class="blue-heading">
          Management Area Fished
        </h6>
            <mat-form-field appearance="outline">
              <mat-label i18n>
            Management Area
          </mat-label>
              <mat-select formControlName="mgmtArea" [compareWith]="compareArea">
                @for (area of managementAreas; track area) {
                  <mat-option [value]="area">
                    {area, select, Area 1 {Area 1} Area 2 {Area 2} Area 3 {Area 3} Area 4 {Area 4} Area 5 {Area 5} Area 6 {Area 6} Area 7 {Area 7} Area 8 {Area 8} Area 9 {Area 9} Area 10 {Area 10} Area 11 {Area 11} Area 12 {Area 12} Area 13 {Area 13} Area 14 {Area 14} Area 15 {Area 15} Area 16 {Area 16} Area 17 {Area 17} Area 18 {Area 18} Area 19 {Area 19} Area 20 {Area 20} Area 21 {Area 21} Area 22 {Area 22} Area 23 {Area 23} Area 24 {Area 24} Area 25 {Area 25} Area 26 {Area 26} Area 27 {Area 27} Area 28 {Area 28} Area 29 {Area 29} Area 101 {Area 101} Area 102 {Area 102} Area 103 {Area 103} Area 104 {Area 104} Area 105 {Area 105} Area 106 {Area 106} Area 107 {Area 107} Area 108 {Area 108} Area 109 {Area 109} Area 110 {Area 110} Area 111 {Area 111} Area 121 {Area 121} Area 123 {Area 123} Area 124 {Area 124} Area 125 {Area 125} Area 126 {Area 126} Area 127 {Area 127} Area 130 {Area 130} Area 142 {Area 142}}
                  </mat-option>
                }
              </mat-select>
              @if (gillnetForm.get('mgmtArea')?.hasError('required')) {
                <mat-error i18n>
            Required
          </mat-error>
              }
              @if (gillnetForm.get('mgmtArea')?.hasError('mgmtAreaMismatch')) {
                <mat-error>
                  Management Area must match the Start Fishing Report area.
                  If fishing a new management area, end this trip then start a new trip
                </mat-error>
              }
            </mat-form-field>
          </div>
          @if (subAreas.length) {
            <div class="row" style="margin-top:20px;">
              <h6 i18n class="blue-heading">
          Subareas Fished
        </h6>
              <mat-form-field appearance="outline">
                <mat-label i18n>
            Subareas
          </mat-label>
                <mat-select formControlName="mgmtSubArea" [compareWith]="compareArea"
                  multiple>
                  @for (subArea of subAreas; track subArea) {
                    <mat-option
                      [value]="subArea">
                      {{subArea}}
                    </mat-option>
                  }
                </mat-select>
                @if (gillnetForm.invalid) {
                  <mat-error i18n>
            Required
          </mat-error>
                }
              </mat-form-field>
            </div>
          }
          <div class="row">
            <div class="row"
              align="center">
              <h5 i18n class="blue-heading-title">
            How many hours did you spend fishing?
          </h5>
            </div>
            <h6 i18n class="blue-heading">
          Hours (round to the nearest half hour)
        </h6>
            <mat-form-field appearance="outline">
              <mat-label i18n>
            Hours
          </mat-label>
              <input matInput
                inputmode="decimal"
                formControlName="hoursFished"
                autocomplete="off"
                (input)="catchService.validateHoursFished('hoursFished', gillnetForm)">
                @if (gillnetForm.get('hoursFished')?.hasError('numericFormat')) {
                  <mat-error i18n>
                    Enter a number, e.g. 12 or 12.5
                  </mat-error>
                }
                @if (gillnetForm.get('hoursFished')?.hasError('required')) {
                  <mat-error i18n>
            Required
          </mat-error>
                }
                @if (gillnetForm.get('hoursFished')?.hasError('min')) {
                  <mat-error i18n>
            Value must be greater than or equal to 0.5
          </mat-error>
                }
                @if (gillnetForm.get('hoursFished')?.hasError('max')) {
                  <mat-error i18n>
            Value must be less than or equal to 24
          </mat-error>
                }
              </mat-form-field>
            </div>
            <!-- Hiding national requirements
            <div class="row" align="center">
              <h5 i18n class="blue-heading-title">
                What was the soaked duration of the gear used for this fishing effort?
              </h5>
            </div>
            <div class="row">
              <div class="row">
                <h6 i18n class="blue-heading">
                  Soak time
                </h6>
              </div>
              <mat-form-field appearance="outline">
                <mat-label i18n>
                  Soak Time
                </mat-label>
                <input matInput type="number" inputmode="numeric" >
                <mat-error i18n *ngIf="gillnetForm.get('soakedDuration')?.hasError('required')">
                  Required
                </mat-error>
                <mat-error i18n *ngIf="gillnetForm.get('soakedDuration')?.hasError('max')">
                  Value must be less than or equal to 99999
                </mat-error>
              </mat-form-field>
            </div>
            <div class="row" align="center">
              <h5 i18n class="blue-heading-title">
                Do you have any remarks to add on the effort by gear?
              </h5>
            </div>
            <div class="row">
              <h6 i18n class="blue-heading">
                Effort by gear comments
              </h6>
              <mat-form-field appearance="fill">
                <mat-label i18n>
                  Comments...
                </mat-label>
                <textarea matInput
                  maxlength="2000"
                  rows="2"
                formControlName="effortGearRemarks"></textarea>
              </mat-form-field>
            </div>
            -->
            <div class="row" align="center">
              <h5 i18n class="blue-heading-title">
          How many sets did you make?
        </h5>
            </div>
            <div class="row">
              <h6 i18n class="blue-heading">
          Number of Sets
        </h6>
              <mat-form-field appearance="outline">
                <mat-label i18n>
            Number of Sets
          </mat-label>
                <input matInput
                  type="number"
                  inputmode="numeric"
                  formControlName="numSets"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
                  @if (gillnetForm.get('numSets')?.hasError('required')) {
                    <mat-error i18n>
            Required
          </mat-error>
                  }
                  @if (gillnetForm.get('numSets')?.hasError('min')) {
                    <mat-error i18n>
            Value must be greater than or equal to 1
          </mat-error>
                  }
                  @if (gillnetForm.get('numSets')?.hasError('max')) {
                    <mat-error i18n>
            Value must be less than or equal to 99
          </mat-error>
                  }
                </mat-form-field>
              </div>
              <!-- Hiding national requirements
              <div class="row">
                <h6 i18n class="blue-heading">
                  Fishing detail comments
                </h6>
                <mat-form-field appearance="fill">
                  <mat-label i18n>
                    Comments...
                  </mat-label>
                  <textarea matInput
                    maxlength="400"
                    rows="4"
                  formControlName="effortDetailComments"></textarea>
                </mat-form-field>
              </div>
              -->
            </div>
          }
          <!-- Catch Table -->
          @if (currPage === 4) {
            <div
              class="container">
              <div class="row"
                align="center">
                <h5 i18n class="blue-heading-title">
          Add or Edit Catch
        </h5>
              </div>
              <table mat-table
                [dataSource]="fishListDetails"
                class="mat-elevation-z8 margin-table">
                <!-- Name Column -->
                <ng-container matColumnDef="speciesName">
                  <tr>
                    <th i18n mat-header-cell
                      *matHeaderCellDef
                      class="heading-cell">
              Species
            </th>
                    <td i18n mat-cell
                      *matCellDef="let element">
              {element.speciesName, select,
              Sockeye {Sockeye}
              Coho (Silver) {Coho (Silver)}
              Pink (Humpy) {Pink (Humpy)}
              Chum (Dog) {Chum (Dog)}
              Chinook (Smiley, King) {Chinook (Smiley, King)}
              Legal Sized Chinook (Smiley, King) {Legal Sized Chinook (Smiley, King)}
              Sublegal Sized Chinook (Smiley, King) {Sublegal Sized Chinook (Smiley, King)}
              Adult Chinook (Smiley, King) {Adult Chinook (Smiley, King)}
              Jack Chinook (Jack Spring, Jax) {Jack Chinook (Jack Spring, Jax)}
              Steelhead {Steelhead}
              Atlantic {Atlantic}
              Salmonids {Salmonids}
              American Shad {American Shad}
              Arrowtooth Flounder (Turbot) {Arrowtooth Flounder (Turbot)}
              Black Rockfish (Black Bass, Sea Bass) {Black Rockfish (Black Bass, Sea Bass)}
              Black Skipjack {Black Skipjack}
              Bocaccio {Bocaccio}
              Canary Rockfish {Canary Rockfish}
              China Rockfish (Yellowstripe) {China Rockfish (Yellowstripe)}
              Chub Mackerel {Chub Mackerel}
              Codfishes {Codfishes}
              Copper Rockfish {Copper Rockfish}
              Dolly Varden {Dolly Varden}
              Dover Sole {Dover Sole}
              Flatfishes {Flatfishes}
              Greenlings {Greenlings}
              Greenstriped Rockfish {Greenstriped Rockfish}
              Jack Mackerel {Jack Mackerel}
              Lampreys {Lampreys}
              Lefteye Flounders {Lefteye Flounders}
              Lingcod {Lingcod}
              Pacific Cod (Gray Cod) {Pacific Cod (Gray Cod)}
              Pacific Hake {Pacific Hake}
              Pacific Halibut {Pacific Halibut}
              Pacific Ocean Perch {Pacific Ocean Perch}
              Pacific Sardine (Pilchard) {Pacific Sardine (Pilchard)}
              Pacific Tomcod (Tommy) {Pacific Tomcod (Tommy)}
              Quillback Rockfish {Quillback Rockfish}
              Ratfishes {Ratfishes}
              Redstripe Rockfish {Redstripe Rockfish}
              Righteye Flounders {Righteye Flounders}
              Sablefishes (Black Cod) {Sablefishes (Black Cod)}
              Sculpins (Bullheads) {Sculpins (Bullheads)}
              Sea Cucumbers {Sea Cucumbers}
              Silvergray Rockfish {Silvergray Rockfish}
              Skipjack Tuna {Skipjack Tuna}
              Southern Rock Sole {Southern Rock Sole}
              Spiny Dogfish (Dog Shark) {Spiny Dogfish (Dog Shark)}
              Starry Flounder {Starry Flounder}
              Sturgeons {Sturgeons}
              Tiger Rockfish {Tiger Rockfish}
              Walleye Pollock {Walleye Pollock}
              Widow Rockfish (Brown Bomber) {Widow Rockfish (Brown Bomber)}
              Yelloweye Rockfish {Yelloweye Rockfish}
              Yellowtail Rockfish {Yellowtail Rockfish}
              }
            </td>
                </tr>
              </ng-container>
              <!-- Kept Column -->
              <ng-container matColumnDef="kept">
                <tr>
                  <th i18n mat-header-cell
                    *matHeaderCellDef
                    class="heading-cell">
              Kept
            </th>
                  <td mat-cell
                    [ngClass]="catchService.determineCellStyling(element.kept, element.speciesName, gillNetTable)"
                    *matCellDef="let element">
                    {{element.kept}}
                  </td>
                </tr>
              </ng-container>
              <!-- Released Column -->
              <ng-container matColumnDef="released">
                <tr>
                  <th i18n mat-header-cell
                    *matHeaderCellDef
                    class="heading-cell">
              Released
            </th>
                  <td mat-cell
                    [ngClass]="catchService.determineCellStyling(element.released)"
                    *matCellDef="let element">
                    {{element.released}}
                  </td>
                </tr>
              </ng-container>
              <!-- Rows -->
              <tr mat-header-row
                *matHeaderRowDef="catchService.catchColumns">
              </tr>
              <tr mat-row
                *matRowDef="let row; columns: catchService.catchColumns; let index=index;"
                (click)="updateSpeciesTable(index)">
              </tr>
            </table>
            <!-- Fish Totals -->
            <div class="row" style="padding-top: 10px;">
              <h6 i18n style="color: #003F61">
          <b>
            Total Fish Kept:
          </b>
          {{catchService.calculateTotalFish('kept', fishListDetails)}}
        </h6>
              <h6 i18n style="color: #003F61">
          <b>
            Total Fish Released:
          </b>
          {{catchService.calculateTotalFish('released', fishListDetails)}}
        </h6>
            </div>
            <div class="row add-item"
              align="center">
              <div class="col-2"></div>
              <div class="col-8">
                <div class="row">
                  <button mat-raised-button
                    class="fishing-button-red"
                    type="button"
                    (click)="updateSpeciesTable(-1)">
                    <span i18n>
                Add New Species
              </span>
                  </button>
                </div>
              </div>
              <div class="col-2"></div>
            </div>
            <!-- This is blocked unless 'other species' has been selected as caught, in which case it becomes mandatory -->
            @if (false) {
              <div class="row">
                <h6 i18n class="blue-heading-title">
          'Other species' has been selected as caught, please provide a description
        </h6>
                <div class="row">
                  <mat-form-field appearance="fill">
                    <mat-label i18n>
              Other species description
            </mat-label>
                    <textarea matInput
                      maxlength="400"
                      rows="5"
                    formControlName="otherSpecies"></textarea>
                  </mat-form-field>
                </div>
              </div>
            }
          </div>
        }
        <!-- Comments -->
        @if (currPage === 5) {
          <div
            class="container">
            <div class="row"
              align="center">
              <h5 i18n class="blue-heading-title">
          Would you like to add a comment?
        </h5>
            </div>
            <div class="row">
              <h6 i18n class="blue-heading">
          Comments
        </h6>
              <mat-form-field appearance="fill">
                <mat-label i18n>
            Comments...
          </mat-label>
                <textarea matInput
                  maxlength="300"
                  formControlName="comments"
                rows="9"></textarea>
              </mat-form-field>
            </div>
          </div>
        }
        <!-- Confirmation Page -->
        @if (currPage > numPages) {
          <div
            class="container">
            @if (!isComplete && !isEditing) {
              <div class="row" align="center">
                <h5 i18n class="blue-heading-title">
          Is all daily catch and logbook information complete and ready to be submitted to DFO?
        </h5>
              </div>
            }
            @if (isEditing) {
              <div class="row"
                align="center">
                <h5 i18n class="blue-heading-title">
          Are these edits correct and ready to be submitted to Archipelago?
        </h5>
              </div>
            }
            @if (isComplete) {
              <div class="row">
                <h6 class="blue-label">
                  <b i18n>
            Confirmation Number:
          </b>
                  @if (catchReport.confirmationNumber === 'Incomplete' ||
                    catchReport.confirmationNumber === 'Not submitted' ||
                    catchReport.confirmationNumber === 'Awaiting response') {
                    <span i18n>
            {catchReport.confirmationNumber, select, Incomplete {Incomplete} Not submitted {Not submitted} Awaiting response {Awaiting response}}
          </span>
                  } @else {
                    {{catchReport.confirmationNumber}}
                  }
                </h6>
              </div>
            }
            @if (this.catchReport.confirmationNumber == 'Not submitted') {
              <div>
                <span i18n class="blue-label">
          Go to the records page to submit outstanding reports
        </span>
              </div>
            }
            @if (reportFailed) {
              <div class="row">
                <button mat-raised-button
                  class="fishing-button-red"
                  type="submit"
                  (click)="reopenReport()"
                  style="width: auto; text-align: left;">
                  <span i18n>
            Reopen report
          </span>
                </button>
              </div>
            }
            <div class="row">
              <h6 i18n class="blue-label">
          <b>Net Used:</b>
          @if (netValid) {
<small
                 class="blue-label">
            {{selectedNet}}
          </small>
}
          @if (!netValid) {
<small class="red-label" (click)="navigateToPage(1)">
            [Required]
            <button mat-icon-button (click)="navigateToPage(1)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </small>
}
        </h6>
            </div>
            <div class="row">
              <h6 i18n class="blue-label">
          <b>Date Fished:</b>
          {{ catchDate | date }}
        </h6>
            </div>
            @if (hasDuplicateDate && !isComplete) {
              <div class="row">
                <small i18n class="red-label" (click)="navigateToPage(2)">
            DFO has already confirmed a catch or pause report for this date — this report will be returned as an error.
            <button mat-icon-button (click)="navigateToPage(2)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </small>
              </div>
            }
            <div class="row">
              <h6 i18n class="blue-label">
          <b>Hours Fished:</b>
          <small class="blue-label">
            {{gillnetForm.get('hoursFished')?.value}}
          </small>
          @if (gillnetForm.get('hoursFished')?.invalid) {
<small class="red-label" (click)="navigateToPage(3)">
            [Required]
            <button mat-icon-button (click)="navigateToPage(3)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </small>
}
        </h6>
            </div>
            <div class="row">
              <h6 class="blue-heading">
                <b i18n>Management Area Fished:</b>
                @if (mgmtAreaValid) {
                  <small i18n
                    class="blue-label">
            {gillnetForm.get('mgmtArea')?.value, select, Area 1 {Area 1} Area 2 {Area 2} Area 3 {Area 3} Area 4 {Area 4} Area 5 {Area 5} Area 6 {Area 6} Area 7 {Area 7} Area 8 {Area 8} Area 9 {Area 9} Area 10 {Area 10} Area 11 {Area 11} Area 12 {Area 12} Area 13 {Area 13} Area 14 {Area 14} Area 15 {Area 15} Area 16 {Area 16} Area 17 {Area 17} Area 18 {Area 18} Area 19 {Area 19} Area 20 {Area 20} Area 21 {Area 21} Area 22 {Area 22} Area 23 {Area 23} Area 24 {Area 24} Area 25 {Area 25} Area 26 {Area 26} Area 27 {Area 27} Area 28 {Area 28} Area 29 {Area 29} Area 101 {Area 101} Area 102 {Area 102} Area 103 {Area 103} Area 104 {Area 104} Area 105 {Area 105} Area 106 {Area 106} Area 107 {Area 107} Area 108 {Area 108} Area 109 {Area 109} Area 110 {Area 110} Area 111 {Area 111} Area 121 {Area 121} Area 123 {Area 123} Area 124 {Area 124} Area 125 {Area 125} Area 126 {Area 126} Area 127 {Area 127} Area 130 {Area 130} Area 142 {Area 142}}
          </small>
                }
                @if (!mgmtAreaValid) {
                  <small i18n class="red-label" (click)="navigateToPage(3)">
            [Required]
            <button mat-icon-button (click)="navigateToPage(3)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </small>
                }
              </h6>
            </div>
            @if (subAreas.length) {
              <div class="row"
                >
                <h6 i18n class="blue-heading">
          <b>Subareas Fished:</b>
          @for (subarea of gillnetForm.get('mgmtSubArea')?.value; track subarea; let index = $index) {
<small class="blue-label"
                >
            @if (index < (gillnetForm.get('mgmtSubArea')?.value.length - 1)) {
<span>
              {{subarea}},
            </span>
}
            @if (index === (gillnetForm.get('mgmtSubArea')?.value.length - 1)) {
<span>
              {{subarea}}
            </span>
}
          </small>
}
          @if (gillnetForm.get('mgmtSubArea')?.errors?.required) {
<small class="red-label" (click)="navigateToPage(3)">
            [Required]
            <button mat-icon-button (click)="navigateToPage(3)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </small>
}
        </h6>
              </div>
            }
            <div class="row">
              <h6 i18n class="blue-heading">
          <b>Number of Sets:</b>
          <small class="blue-label">
            {{gillnetForm.get('numSets')?.value}}
          </small>
          @if (gillnetForm.get('numSets')?.errors?.required) {
<small class="red-label" (click)="navigateToPage(3)">
            [Required]
            <button mat-icon-button (click)="navigateToPage(3)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </small>
}
          @if (gillnetForm.get('numSets')?.errors?.min || gillnetForm.get('numSets')?.errors?.max) {
<small class="red-label" (click)="navigateToPage(3)">
            [Invalid]
            <button mat-icon-button (click)="navigateToPage(3)">
              <mat-icon style="color: red;">edit</mat-icon>
            </button>
          </small>
}
        </h6>
            </div>
            <div class="row">
              <h6 i18n class="blue-heading">
          <b>Total Fish Kept:</b>
          <small class="blue-label">
            {{catchService.calculateTotalFish('kept', fishListDetails)}}
          </small>
        </h6>
            </div>
            <div class="row">
              <h6 i18n class="blue-heading">
          <b>Total Fish Released:</b>
          <small class="blue-label">
            {{catchService.calculateTotalFish('released', fishListDetails)}}
          </small>
        </h6>
            </div>
            <div class="row">
              <h6 i18n class="blue-heading">
          <b>Comments:</b>
          <small class="blue-label">
            {{gillnetForm.get('comments')?.value}}
          </small>
        </h6>
            </div>
          </div>
        }
      </form>
      <!-- Navigation Buttons -->
      @if (!isComplete) {
        <div class="row" style="margin-top: auto; padding-bottom: 3%; padding-top: 10px">
          <div class="col-1"></div>
          <div class="col-4">
            <div class="row">
              <button mat-raised-button
                class="fishing-button-blue"
                type="button"
                (click)="toPreviousPage()">
                <span i18n>
            Back
          </span>
              </button>
            </div>
          </div>
          <div class="col-2"></div>
          <div class="col-4">
            <div class="row">
              <button mat-raised-button
                class="fishing-button-red"
                type="submit"
                (click)="toNextPage()">
                @if (currPage <= numPages) {
                  <span i18n>
            Next
          </span>
                }
                @if (currPage > numPages) {
                  <span i18n>
            Submit
          </span>
                }
              </button>
            </div>
          </div>
          <div class="col-1"></div>
        </div>
      }
      @if (isComplete) {
        <div class="row bottom-buttons" style="display: flex; justify-content: center;">
          <div class="col-4">
            <div class="row" style="display: flex; justify-content: center;">
              <button mat-raised-button
                class="fishing-button-blue"
                type="button"
                (click)="toPreviousPage()">
                <span i18n>
            Back
          </span>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
